import { render, staticRenderFns } from "./FormSocialNetworks.vue?vue&type=template&id=78ab88ae"
import script from "./FormSocialNetworks.vue?vue&type=script&lang=js"
export * from "./FormSocialNetworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports